import React, {useEffect, useState} from "react";
import {Playertool} from "../Util/PlayerTool/Playertool";
import {Col, Row, Card, Upload, Button, Typography, message, List, Avatar, Drawer, Tag} from "antd";
import { Tabs } from 'antd';
import {getFileAddress, getFrontEndAddress, getHostAddress} from "../../Tool/UtileFun";
import cookie from "react-cookies";
import {SyncOutlined, UploadOutlined, VideoCameraOutlined} from '@ant-design/icons';
import Player from 'griffith'
import {FileViewerTool} from "../Util/fileViewer/FileViewerTool";
import {Scrollbars} from "react-custom-scrollbars";
import {IsDownLoad} from "./IsDownLoad";

export function VideoAndList(){

    useEffect(
        ()=>{
            loadExperiment()
            loadVideoList()
            //setVideoAddress(<Player sources={sources}></Player>)
            changeVideoAddress({resourcesAddress:""})
            //getUploadFileList()
            uploadTaskList()
            findSourcesAddress()
        },[]
    );

    const role = "role"
    const userId = "userId"
    const experimentID = "experimentID"
    const { TabPane } = Tabs;
    const { Text, Link } = Typography;

    const [experiment,setExperiment] = useState({})
    const [videoList,setVideoList] = useState([])
    const [videoAddress,setVideoAddress] = useState()
    const [videoConfig,setVideoConfig] = useState()
    const [add,setAdd] = useState("")
    const [uploadFileList,setUploadFileList] = useState([])
    const [otherFile,setOtherFile] = useState([])
    const [load,setLoad] = useState(false)
    const [fileInfo,setFileInfo] = useState({})
    const [isModalVisible, setIsModalVisible] = useState(false);

    const callback = (key)=> {
        console.log(key);
    }

    const loadExperiment=()=>{
        fetch(
            "http://"+getHostAddress()+"/experiment/findById",
            {
                method:'post',
                headers:{
                    'Content-Type':'application/json',
                },
                body:JSON.stringify({id:cookie.load(experimentID)}),
            }
        )
            .then( res =>{ if( res.ok) return res.json()
            })
            .then(data=>{
                setExperiment(data)
            })
            .catch(error => message.error("error"+error));
    }

    const loadVideoList=(value)=>{
        fetch(
            "http://"+getHostAddress()+"/resourcesAddress/findByExperimentIdVideo",
            {
                method:'post',
                headers:{
                    'Content-Type':'application/json',
                },
                body:JSON.stringify({id:cookie.load(experimentID)}),
            }
        )
            .then( res =>{ if( res.ok) return res.json()
            })
            .then(data=>{
                setVideoList(data)

                //这里设置初始加载的视频地址
                //这里设置初始加载的视频地址
                if (data[0]!=null && data[0]!=undefined && data[0]!="" && data!="{}"){
                    if (ifFormat(data[0].relativeAddress)) {
                        //关闭文件查看器
                        setShowFileState()
                        //开启视频查看器
                        setPlayerstateId(data[0].id)
                        setVideoAddress(pl(data[0]))
                    }else {
                        let props = {
                            //filePath:data[0].resourcesAddress,
                            fileType:getFormat(data[0].relativeAddress),
                            relativeAddress:data[0].relativeAddress
                        }
                        //关闭视频查看器
                        setVideoAddress()

                        setPlayerstateId(data[0].id)
                        //开启文件查看器
                        setShowFileState(<Col style={{height:document.body.clientHeight - (document.body.clientHeight * 0.2),backgroundColor:"white"}}><FileViewerTool style={{position:"relative",zIndex:10}} {...props}></FileViewerTool></Col>)
                    }
                }
            })
            .catch(error => message.error("error"+error));
    }

    const getFormat=(fileName)=>{
        let format = ""
        let realFormat = ""
        for (let i = fileName.length - 1; i >= 0; i--) {
            console.log(fileName[i])
            if (fileName[i] === "."){
                break
            }
            if (fileName[i] !== "."){
                format = format + fileName[i]
            }
        }

        for (let i = format.length - 1 ; i >= 0 ; i--) {
            if (format[i] !=="."){
                realFormat = realFormat + format[i]
            }
        }
        return realFormat
    }

    const [showFileState,setShowFileState] =useState()
    const ifFormat=(fileName)=>{
        let format = ""
        let realFormat = ""
        for (let i = fileName.length - 1; i >= 0; i--) {
            console.log(fileName[i])
            if (fileName[i] === "."){
                break
            }
            if (fileName[i] !== "."){
                format = format + fileName[i]
            }
        }

        for (let i = format.length - 1 ; i >= 0 ; i--) {
            if (format[i] !=="."){
                realFormat = realFormat + format[i]
            }
        }
        if (realFormat==="mp4"){
            return true
        }else {
            return false
        }
    }

    const saveFilePath=(value)=>{
        fetch(
            "http://"+getHostAddress()+"/resourcesAddress/savePath",
            {
                method:'post',
                headers:{
                    'Content-Type':'application/json',
                },
                body:JSON.stringify({classId:cookie.load("classID"),realName:value.realName,fileName:value.fileName,experimentId:cookie.load(experimentID),userId:cookie.load(userId)}),
            }
        )
            .then( res =>{ if( res.ok) return res.json()
            })
            .then(data=>{

            })
            .catch(error => message.error("error"+error));
    }

    const saveTask=(value)=>{
        fetch(
            "http://"+getHostAddress()+"/task/saveTask",
            {
                method:'post',
                headers:{
                    'Content-Type':'application/json',
                },
                body:JSON.stringify({classId:cookie.load("classID"),realName:value.realName,fileName:value.fileName,experimentId:cookie.load(experimentID),userId:cookie.load(userId)}),
            }
        )
            .then( res =>{ if( res.ok) return res.json()
            })
            .then(data=>{

            })
            .catch(error => message.error("error"+error));
    }

    const taskExists=(value)=>{
        fetch(
            "http://"+getHostAddress()+"/resourcesAddress/taskExists",
            {
                method:'post',
                headers:{
                    'Content-Type':'application/json',
                },
                body:JSON.stringify({realName:value.realName,fileName:value.fileName,experimentId:cookie.load(experimentID),userId:cookie.load(userId),classId:cookie.load("classID")}),
            }
        )
            .then( res =>{ if( res.ok) return res.json()
            })
            .then(data=>{
                if (data.ex === "exists"){
                    console.log("存在")
                    let taskInfo = data.taskInfo
                    let id = taskInfo.id
                    updateTaskRelative({id:id,fileName:value.fileName,relativeAddress:value.relativeAddress})
                }else{
                    //如果不存在   为首次上传时将数据写入数据
                    //saveFilePath({fileName:value.fileName,realName:value.realName})
                    saveTask({fileName:value.fileName,realName:value.realName})
                    //刷新上传列表
                    //getUploadFileList()
                    uploadTaskList()
                }
            })
            .catch(error => message.error("error"+error));
    }

    const updateTaskRelative=(value)=>{
        fetch(
            "http://"+getHostAddress()+"/task/updateTaskRelative",
            {
                method:'post',
                headers:{
                    'Content-Type':'application/json',
                },
                body:JSON.stringify({fileName:value.fileName,taskId:value.id,relative:value.relativeAddress}),
            }
        )
            .then( res =>{ if( res.ok) return res.json()
            })
            .then(data=>{

            })
            .catch(error => message.error("error"+error));
    }

    const getUploadFileList=(value)=>{
        fetch(
            "http://"+getHostAddress()+"/upLoadFileListApi/getUserUpLoadFileList",
            {
                method:'post',
                headers:{
                    'Content-Type':'application/json',
                },
                body:JSON.stringify({experimentId:cookie.load(experimentID),userId:cookie.load(userId)}),
            }
        )
            .then( res =>{ if( res.ok) return res.json()
            })
            .then(data=>{
                console.log("-------getupload------")
                console.log(cookie.load(experimentID))
                console.log(cookie.load(userId))
                console.log(data)
                setUploadFileList(data)
            })
            .catch(error => message.error("error"+error));
    }

    const uploadTaskList=(value)=>{
        fetch(
            "http://"+getHostAddress()+"/task/uploadTaskList",
            {
                method:'post',
                headers:{
                    'Content-Type':'application/json',
                },
                body:JSON.stringify({experimentId:cookie.load(experimentID),userId:cookie.load(userId),classId:cookie.load("classID")}),
            }
        )
            .then( res =>{ if( res.ok) return res.json()
            })
            .then(data=>{
                setUploadFileList(data)
            })
            .catch(error => message.error("error"+error));
    }


    const lists = (
        <List
            itemLayout="horizontal"
            dataSource={videoList}
            pagination={{
                onChange: page => {
                    console.log(page);
                },
                pageSize: 3,
            }}
            renderItem={item => (
                <List.Item>
                    <List.Item.Meta
                        avatar={<VideoCameraOutlined />}
                        title={<a onClick={()=>changeVideoAddress(item)}>{item.resourcesName}{playerIoc(item)}</a>}
                        //description={item.content}
                    />
                </List.Item>
            )}
        />
    )

    const propsData = {
        name: 'file',
        action: "http://"+getHostAddress()+"/resourcesAddress/upload",
        headers: {
            authorization: 'authorization-text',
        },
        beforeUpload(file) {
            if (file.size > 1048576*500){
                message.info("上传文件最大支持500MB")
                return false
            }
            return true
        },
        onChange(info) {
            if (info.file.status !== 'uploading') {
                console.log(info.file, info.fileList);
                console.log("返回")
                console.log(info.file.response)
            }
            if (info.file.status === 'done' && info.file.response.state === 'success') {
                message.success(`${info.file.name} 上传成功`);
                console.log("------------------------")
                 taskExists({fileName:info.file.name,realName:info.file.response.newFileName,relativeAddress:info.file.response.address})
                //如果成功则将地址写入数据库
                //saveFilePath({fileName:info.file.name,realName:info.file.response.newFileName})
                //刷新上传列表
                //getUploadFileList()
                //setUploadFileList()
                //info.file.response.newFileName
            } else if (info.file.status === 'error' && info.file.response.state === 'error') {
                message.error(`${info.file.name} 上传失败`);
            }
        },
        defaultFileList:uploadFileList,
    };

    let vAddress
    let sources = {
        hd: {
            play_url: add.resourcesAddress,
        },
        sd: {
            play_url: add.resourcesAddress,
        },
    }
    const playerId = {
        id:add.id === ""||add.id===''?'0':add.id
    }


    const changeVideoAddress = (value) =>{
        //setVideoAddress(<Player sources={sources}></Player>)
        //window.opener.location.href=window.opener.location.href;
        setVideoAddress(pl(value))
        setAdd(value)
        console.log(value)

        if (value.relativeAddress === null || value.relativeAddress === undefined){

        }else {
            //判断文件格式
            if (ifFormat(value.relativeAddress)){
                //关闭文件查看器
                setShowFileState()
                //开启视频查看器
                setPlayerstateId(value.id)
                setVideoAddress(pl(value))
                setAdd(value)
            }else {
                let temp = value.resourcesAddress
                let props = {
                    //filePath:value.resourcesAddress,
                    fileType:getFormat(value.relativeAddress),
                    relativeAddress:value.relativeAddress,
                    height:"800px"
                }
                //关闭视频查看器
                setVideoAddress()
                console.log("文件查看器")
                console.log(props.fileType)
                console.log(props.relativeAddress)

                setPlayerstateId(value.id)
                //开启文件查看器
                setShowFileState(<Col style={{height:document.body.clientHeight - (document.body.clientHeight * 0.2),backgroundColor:"white"}}><FileViewerTool style={{position:"relative",zIndex:10}} {...props}></FileViewerTool></Col>)
            }
        }
    }

    //根据实验id获取实验资源
    const findSourcesAddress=(value)=>{
        fetch(
            "http://"+getHostAddress()+"/resourcesAddress/findOtherFileList",
            {
                method:'post',
                headers:{
                    'Content-Type':'application/json',
                },
                body:JSON.stringify({experimentId:cookie.load(experimentID),role:cookie.load(role)}),
            }
        )
            .then( res =>{ if( res.ok) return res.json()
            })
            .then(data=>{
                setOtherFile(data)
            })
            .catch(error => message.error("error"+error));
    }

    const showModal = (fileData) => {
        cookie.save("filePath",fileData.filePath)
        cookie.save("fileType",fileData.fileType)
        //window.open(getFrontEndAddress()+"/user/fileView")
        console.log("-------fileDatasssss-------")
        console.log(fileData)
        setLoad(true)
        setFileInfo(fileData)
        setIsModalVisible(true);
    };

    const icon = (type)=>{
        if (type === 'xlsx'){
            return "http://"+getFileAddress()+"/experimentResources/icon/xlsx.jpg"
        }
        if (type === 'pptx'){
            return "http://"+getFileAddress()+"/experimentResources/icon/ppt.jpg"
        }
        if (type === 'docx'){
            return "http://"+getFileAddress()+"/experimentResources/icon/docx.jpg"
        }
        if (type === 'jpg'){
            return "http://"+getFileAddress()+"/experimentResources/icon/picture.jpg"
        }
        return "http://"+getFileAddress()+"/experimentResources/icon/otherFile.jpg"
    }



    const otherFileList = (
        <List
            itemLayout="horizontal"
            dataSource={otherFile}
            pagination={{
                onChange: page => {
                    console.log(page);
                },
                pageSize: 3,
            }}
            renderItem={item => (
                <List.Item
                    actions={[<a  onClick={()=>showModal({filePath:item.resourcesAddress,fileType:item.type,relativeAddress:item.relativeAddress})} key="list-loadmore-edit" target={"_blank"} download="filename">预览</a>]}
                >
                    <List.Item.Meta
                        avatar={<Avatar src={icon(item.type)} />}
                        title={<IsDownLoad {...item}></IsDownLoad>}
                        description={item.content}
                    />
                </List.Item>
            )}
        />
    )


    const [playerstateId,setPlayerstateId] = useState()
    const playerIoc = (value) =>{
        if(value.id === playerstateId){
            return <Tag icon={<SyncOutlined spin />} color="success">正在播放中</Tag>
        }
    }


    let pl = (value) =>{
        let sources = {
            hd: {
                play_url: "http://"+getFileAddress() +value.relativeAddress,
            },
            sd: {
                play_url: "http://"+getFileAddress() +value.relativeAddress,
            },
        }
        const propss = {
            id:value.id,
            title:value.resourcesName,
            cover:"http://"+getFileAddress() +"/experimentResources/icon/videoCover.jpg"
        }
        return <Player sources={sources} {...propss}></Player>
    }

    const handleCancel = () => {
        setIsModalVisible(false);
        setFileInfo("")
    };

    const fileViewFun=()=>{
        if (load === true)
            return <FileViewerTool {...fileInfo}></FileViewerTool>
    }

    let borSty = {
        //border:"1px solid red",
        height:document.body.clientHeight - (document.body.clientHeight * 0.2)
    }

    let scrollbarsSty = {
        height:document.body.clientHeight - (document.body.clientHeight * 0.4)
    }

    return(
        <>
        <Drawer
            title=""
            width={720}
            onClose={handleCancel}
            visible={isModalVisible}
            bodyStyle={{ paddingBottom: 80 }}
        >
            {fileViewFun()}
        </Drawer>
        <Row  style={borSty}>
            <Col style={borSty} span={10}>
                <Card style={borSty}>
                    <Tabs defaultActiveKey="1"
                          tabPosition={"left"}
                          style={borSty}
                    >
                        <TabPane tab="实验概述" key="1">
                            <p>实验名称:&nbsp;{experiment.target}</p>
                            {/*<p>{experiment.content}</p>*/}
                            <Card>
                                <Scrollbars style={scrollbarsSty}>
                                    <div className="braft-output-content" dangerouslySetInnerHTML={{__html: experiment.description}} />
                                </Scrollbars>
                            </Card>
                        </TabPane>
                        <TabPane tab="实验内容" key="2">
                            <Card>
                                <Scrollbars style={scrollbarsSty}>
                                    <div className="braft-output-content" dangerouslySetInnerHTML={{__html: experiment.content}} />
                                </Scrollbars>
                            </Card>
                        </TabPane>
                        <TabPane tab="实验步骤" key="3">
                            <Card>
                                <Scrollbars style={scrollbarsSty}>
                                    <div className="braft-output-content" dangerouslySetInnerHTML={{__html: experiment.step}} />
                                </Scrollbars>
                            </Card>
                        </TabPane>
                        <TabPane tab="实验讲解" key="4">
                            <Card>
                                <Scrollbars style={{  height:document.body.clientHeight - (document.body.clientHeight * 0.6) }}>
                                    <div className="braft-output-content" dangerouslySetInnerHTML={{__html: experiment.teach}} />
                                </Scrollbars>
                            </Card>
                            {lists}
                        </TabPane>
                        <TabPane tab="作业上传" key="5">
                            <Upload {...propsData}>
                                <Button icon={<UploadOutlined />}>作业上传</Button>
                            </Upload>
                        </TabPane>
                        <TabPane tab="其他文件" key="6">
                            {otherFileList}
                        </TabPane>
                    </Tabs>
                </Card>
            </Col>
            <Col style={borSty} span={14}>
                {/*<Player sources={videoAddress} />*/}
                {/*<Playertool url={videoAddress}></Playertool>*/}
                {videoAddress}
                {showFileState}
                {/*<Player sources={sources}></Player>*/}
            </Col>
        </Row>
        </>
    )
}
